export const containerFromStore = state => state.app.decryptedContainer
export const walletAddressFromStore = state => state.app.validWalletAddress
export const currenciesFromStore = state => state.app.currencies
export const ambiVaultUserContractFromStore = state => state.app.ambiVaultUserContract
export const customDataFromStore = state => state.app.customCallData
export const walletOwnerAddressFromStore = state => state.app.walletOwnerAddress
